import { lazy, Suspense, useEffect, useState } from "react";
import PodcastService from "services/podcast/PodcastService";
import { useSelector } from "react-redux";
import TrendingPodcastSkeleton from "components/skeleton/TrendingPodcastSkeleton";

const PodcastHeroCard = lazy(() => import("./PodcastHeroCard"));
const PodcastGridSection = lazy(() => import("./PodcastGridSection"));

function PodcastHeroSection({ latest }: any) {
  const [categories, setCategories] = useState<any>([]);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    setIsLoading(true);
    PodcastService.getAllCategories().then((res) => {
      setIsLoading(false);
      setCategories(res.data);
    });
  }, []);

  return (
    <>
      {!isLoading && (
        <Suspense fallback={<TrendingPodcastSkeleton />}>
          <div className="mr-5 mt-10 flex gap-6 max-lg:mr-0 max-lg:flex-col max-lg:gap-4">
            <div className="w-full shrink-0 lg:w-[420px] xl:w-[460px]">
              {latest && (
                <PodcastHeroCard latestPodcast={latest} isLoading={isLoading} />
              )}
            </div>
            <div className="min-w-0 flex-1">
              {categories && (
                <PodcastGridSection
                  categories={categories}
                  user={loggedInUser}
                />
              )}
            </div>
          </div>
        </Suspense>
      )}
      {isLoading && <TrendingPodcastSkeleton />}
    </>
  );
}

export default PodcastHeroSection;